module.exports = __webpack_public_path__ + "static/img/IMG_20160604_095724.89efdc5d.jpg";